import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useLang } from "@/lib/LanguageContext";
import { card } from "@/lib/images";
import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";
import ImageHero from "@/components/ImageHero";

export default function AboutPage() {
  const { t } = useLang();
  const a = t.about;

  return (
    <PageShell>
      <Seo title={a.seoTitle} description={a.seoDesc} />

      <ImageHero testId="about-hero" image="glassDome" eyebrow={a.eyebrow} titleA={a.title} titleB={a.titleB} />

      <section data-testid="about-body" className="py-16 sm:py-32 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 overflow-hidden aspect-[4/3] lg:aspect-[4/5] bg-stone-200">
            <img src={card("apartment")} alt="Book & Smile — Paris" loading="lazy" className="w-full h-full object-cover" />
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="space-y-8 text-stone-700 text-base md:text-lg leading-relaxed">
              <p data-testid="about-p1">{a.p1}</p>
              <p>{a.p2}</p>
              <p>{a.p3}</p>
            </div>
            <h2 className="font-serif mt-16 text-base md:text-lg text-stone-900">{a.valuesTitle}</h2>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-8">
              {a.values.map((v) => (
                <div key={v.title} className="border-t border-stone-200 pt-6">
                  <h3 className="font-medium text-stone-900">{v.title}</h3>
                  <p className="mt-2 text-stone-600 text-sm leading-relaxed">{v.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section data-testid="about-cta" className="bg-stone-100 border-t border-stone-200 py-16 sm:py-32 px-6 lg:px-10 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-serif text-4xl sm:text-5xl font-light text-stone-900">{t.finalCta.title}</h2>
          <Link
            data-testid="about-cta-contact"
            to="/contact"
            className="mt-10 inline-flex items-center justify-center gap-3 bg-slate-900 text-stone-50 px-8 py-4 text-sm font-medium hover:bg-slate-800 transition-colors"
          >
            {t.finalCta.cta}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </PageShell>
  );
}
